// eslint-disable-next-line jira/filename-case
import React, { useEffect, useRef } from 'react';
import { JiraEntryPointContainer } from '@jira/platform__entry-points-container/src/index.tsx';
// eslint-disable-next-line jira/restricted/@atlassian+jira-entry-point
import { useEntryPoint } from '@jira/platform__entry-point/src/controllers/use-entry-point/index.tsx';
import { JWM_INVITE_TEAM_NUDGE_ID } from '@jira/platform__onboarding-core/src/constants.tsx';
import {
	useHasNudgeActive,
	useNudgeStep,
} from '@jira/platform__onboarding-quickstart-core/src/services/index.tsx';
import { ERROR_BOUNDARY_ID_JWM_INVITE_TEAM_NUDGE } from './errorBoundaryIdJwmFormTourNudge.constants.tsx';
import { inviteTeamNudgeEntryPoint } from './inviteTeamNudgeEntryPoint.entrypoint.tsx';

const runtimeProps = {};
const entryPointParams = {};

export const InviteTeamNudgeAsync = (): React.JSX.Element => {
	const { entryPointActions, entryPointReferenceSubject } = useEntryPoint(
		inviteTeamNudgeEntryPoint,
		entryPointParams,
	);

	const [nudgeStep] = useNudgeStep();
	const [hasNudgeActive] = useHasNudgeActive();
	const firstLoadRef = useRef(true);

	// eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
	useEffect(() => {
		if (firstLoadRef.current && hasNudgeActive && nudgeStep === JWM_INVITE_TEAM_NUDGE_ID) {
			entryPointActions.load();
			firstLoadRef.current = false;
		}
	}, [entryPointActions, hasNudgeActive, nudgeStep]);

	return (
		<JiraEntryPointContainer
			id={ERROR_BOUNDARY_ID_JWM_INVITE_TEAM_NUDGE}
			packageName="jiraInviteTeamOnboarding"
			entryPointReferenceSubject={entryPointReferenceSubject}
			fallback={<></>}
			runtimeProps={runtimeProps}
		/>
	);
};
